// extracted by mini-css-extract-plugin
module.exports = {"container":"GiftCardOption_container__mzD1i","title":"GiftCardOption_title__qOc4G","description":"GiftCardOption_description__4uayQ","active":"GiftCardOption_active__3p48k"};